export default "__VITE_ASSET__CgSlpM4N__"